export function EmptyChart() {
  return (
    <div
      className="muted"
      style={{ padding: "48px 16px", textAlign: "center", fontSize: 13 }}
    >
      No activity in this range.
    </div>
  );
}
